import { TaskStep, TestData } from "graphql/types"
import { getTextForTaskStep } from "utils/taskSteps"
import { getTimeDifferencFormated } from "./dateTimeUtils"
import { getJaNein } from "./getJaNein"
import { getResultTypeName } from "./resultTypes"

export const createNewHistoryEntry = (data: TestData, taskType: TaskStep): string[] => {
  const returnValue = [
    `${getTextForTaskStep(taskType)}-Daten erfasst: ${data.name}`,
    data.description !== "" ? `Beschreibung: ${data.description}` : "",
  ].filter((item) => item !== "")

  switch (taskType) {
    case TaskStep.NOTE:
      return returnValue

    case TaskStep.FUNCTION_TEST:
      // TODO: Add EUT-Images
      const testedEuts = data.deviceTestData.map((item) => {
        const result = item.result.map((result) => {
          return `${result.criteria} - ${result.operatingMode} - ${getResultTypeName(result.type)}`
        })

        return [
          `${item.device.barcode}: ${result.join("\n")}`,
          item.note !== "" ? `Anmerkung: ${item.note}` : "",
        ]
      })
      returnValue.push(...testedEuts.flat().filter((item) => item !== ""))
      return returnValue

    case TaskStep.TEST_CONFIGURATION:
      returnValue.push(...[`Ambiente Conditions: ${getJaNein(data.ambientConditions)}`])
      if (data.image.length > 0) {
        const fotos = data.image
          .map((item) => {
            return `${item.fileURL}`
          })
          .join("','")
        returnValue.push(`ImageURL: ${fotos}`)
      }
      return returnValue

    case TaskStep.TEST_FOLLOW_UP:
      // TODO: Add EUT-Images
      const euts = data.deviceTestData.map((item) => {
        const result = item.result.map((result) => {
          return `${result.criteria} - ${result.operatingMode} - ${getResultTypeName(result.type)}`
        })

        return [
          `${item.device.barcode}: ${result.join("\n")}`,
          item.note !== "" ? `Anmerkung: ${item.note}` : "",
        ]
      })
      returnValue.push(
        `Visuelle Kontrolle erfolgreich: ${getJaNein(data.visualCheck)}`,
        ...euts.flat().filter((item) => item !== "")
      )
      if (data.image.length > 0) {
        const fotos = data.image
          .map((item) => {
            return `${item.fileURL}`
          })
          .join("','")
        returnValue.push(`ImageURL: ${fotos}`)
      }
      return returnValue

    case TaskStep.ENGINEERING:
      if (data.image.length > 0) {
        const fotos = data.image
          .map((item) => {
            return `${item.fileURL}`
          })
          .join("','")
        returnValue.push(`ImageURL: ${fotos}`)
      }
      return returnValue

    case TaskStep.WAITING_TIME:
      returnValue.push(`Dauer: ${getTimeDifferencFormated(data.beginTime, data.endTime)}`)
      return returnValue
    case TaskStep.HELPER:
      const helper = data.helper.map((item) => {
        return `Hilfstkraft: ${item.displayName}`
      })
      returnValue.push(
        ...[...helper, `Dauer: ${getTimeDifferencFormated(data.beginTime, data.endTime)}`]
      )
      return returnValue

    default:
      return returnValue
  }
}

export const createChangeHistoryEntry = (
  oldData: TestData,
  newData: TestData,
  taskType: TaskStep
): string[] => {
  const returnValue = [
    oldData.name !== newData.name
      ? `${getTextForTaskStep(taskType)}-Daten geändet von ${oldData.name} zu ${newData.name}`
      : "",
    oldData.description !== newData.description
      ? `Beschreibung von ${oldData.description} zu ${newData.description}`
      : "",
  ]?.filter((item) => item !== "")

  switch (taskType) {
    case TaskStep.NOTE:
      return returnValue

    case TaskStep.FUNCTION_TEST:
      // TODO: Add EUT-Images
      const testedEuts = newData.deviceTestData.map((item, index) => {
        const oldItem = oldData.deviceTestData[index]
        return [
          oldItem?.device.barcode !== item.device.barcode
            ? `${oldItem.device.barcode} geändert zu ${item.device.barcode}`
            : "",

          oldItem?.note !== item.note
            ? `${item.device.barcode} - Anmerkung geändert von ${oldItem.note} zu ${item.note}`
            : "",
        ].filter((item) => item !== "")
      })
      returnValue.push(...testedEuts.flat())

      return returnValue

    case TaskStep.TEST_CONFIGURATION:
      returnValue.push(
        ...[
          oldData.ambientConditions !== newData.ambientConditions
            ? `Ambiente Conditions geändert von ${oldData.ambientConditions} zu ${newData.ambientConditions}`
            : "",
        ].filter((item) => item !== "")
      )
      const resultSet = newData.image?.filter(
        (item1) => !oldData.image.some((item2) => item1.id === item2.id)
      )
      if (resultSet && resultSet.length > 0) {
        const fotos = resultSet
          .map((item) => {
            return `${item.fileURL}`
          })
          .join("','")
        returnValue.push(`ImageURL: ${fotos}`)
      }
      return returnValue

    case TaskStep.TEST_FOLLOW_UP:
      // TODO: Add EUT- Images
      const euts = newData.deviceTestData.map((item, index) => {
        const oldItem = oldData.deviceTestData[index]
        return [
          oldItem?.device.barcode !== item.device.barcode
            ? `${oldItem.device.barcode} geändert zu ${item.device.barcode}`
            : "",

          oldItem?.note !== item.note
            ? `${item.device.barcode} - Anmerkung geändert von ${oldItem.note} zu ${item.note}`
            : "",
        ].filter((item) => item !== "")
      })
      returnValue.push(
        oldData.visualCheck !== newData.visualCheck
          ? `Visuelle Kontrolle erfolgreich geändert von ${getJaNein(oldData.visualCheck)} zu ${getJaNein(newData.visualCheck)}`
          : "",
        ...euts.flat()
      )
      const resultFol = newData.image.filter(
        (item1) => !oldData.image.some((item2) => item1.id === item2.id)
      )
      if (resultFol.length > 0) {
        const fotos = resultFol
          .map((item) => {
            return `${item.fileURL}`
          })
          .join("','")
        returnValue.push(`ImageURL: ${fotos}`)
      }
      return returnValue

    case TaskStep.ENGINEERING:
      const resultEng = newData.image.filter(
        (item1) => !oldData.image.some((item2) => item1.id === item2.id)
      )
      if (resultEng.length > 0) {
        const fotos = resultEng
          .map((item) => {
            return `${item.fileURL}`
          })
          .join("','")
        returnValue.push(`ImageURL: ${fotos}`)
      }
      return returnValue

    case TaskStep.WAITING_TIME:
      returnValue.push(
        oldData.beginTime !== newData.beginTime || oldData.endTime !== newData.endTime
          ? `Dauer geändert von ${getTimeDifferencFormated(oldData.beginTime, oldData.endTime)} zu ${getTimeDifferencFormated(newData.beginTime, newData.endTime)}`
          : ""
      )
      return returnValue

    case TaskStep.HELPER:
      const helper = newData.helper.map((item) => {
        return `Hilfstkraft: ${item.displayName}`
      })

      returnValue.push(
        ...[
          ...helper,
          oldData.beginTime !== newData.beginTime || oldData.endTime !== newData.endTime
            ? `Dauer geändert von ${getTimeDifferencFormated(oldData.beginTime, oldData.endTime)} zu ${getTimeDifferencFormated(newData.beginTime, newData.endTime)}`
            : "",
        ].filter((item) => item !== "")
      )
      return returnValue

    default:
      return returnValue
  }
}
